/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useQuery } from "@tanstack/react-query";

const useInactiveVolunteerList = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;

  const {
    refetch: inActiveRefetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: inActiveVolunteerInfo = [],
  } = useQuery({
    queryKey: ["InactiveVolunteer"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/inactiveVoluntereList`
      );
      const data = await res.json();
      // console.log("inactive data list", data.data);
      return data.data;
    },
  });

  return [
    inActiveVolunteerInfo,
    isLoading,
    isError,
    error,
    isSuccess,
    inActiveRefetch,
  ];
};

export default useInactiveVolunteerList;
